import { makeStyles } from '@material-ui/core'
import { spacing } from '../../style-guide'

export const useStyles = makeStyles({
  input: {
    marginBottom: spacing.xs
  },

  download: {
    marginTop: spacing.xs
  },
  status: {
    ...spacing.marginY.m
  }
})
